<template>
    <div @click="handleMapType" :class="['map-type', isMobileSize ? 'mobile' : 'pc', status]" :style="css">
        <span class="iconfont" :class="icon ? icon : 'icon-resize'"></span>
        <site-img :src="iconImg" />
        <p>{{ text }}</p>
    </div>
</template>
<script setup>
import { defineProps } from 'vue';
import siteImg from '../../global/site-img.js';
import { useMapType } from '@/components/map/hook/useMapType';
defineProps({
    icon: {
        type: String,
        default: 'icon-a-arrowswitch'
    },
    css: {
        type: [String, Object],
        default: ''
    }
})   

const { isMobileSize, status, text, iconImg, handleMapType } = useMapType()
</script>
<style lang="scss">
.map-type {
    transition: ease all 0.3s;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
    border: 2px solid #fff;
    .iconfont {
        transition: ease all 0s;
        transition-delay: 0.2s;
        position: absolute;
        left: 0;
        bottom: 0;
        height: 48px;
        width: 48px;
        text-align: center;
        &::before {
            font-size: 40px;
            line-height: 48px;
            color: #fff;
            text-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        }
    }
    img {
        width: 48px;
        height: 48px;
        vertical-align: middle;
        transition: ease all 0.3s;
    }
    p {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        color: #fff;
        font-size: 14px;
        text-align: center;
        transition: ease all 0s;
        transition-delay: 0.2s;
        display: none;
        background-color: rgba(0, 0, 0, 0.2);
        text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
        font-family: var(--font-medium);
    }
    &.roadmap {
        p {
            color: #202437;
            background-color: transparent;
        }
    }

    @media (min-width: 601px){
        &:hover {
            .iconfont {
                display: none;
            }
            img {
                width: 76px;
                height: 76px;
            }
            p {
                display: block;
                line-height: 80px;
            }
        }
    }
    @media (max-width: 600px) {
        border-width: 1px;
        .iconfont {
            width: 28px;
            height: 28px;
            &::before {
                font-size: 24px;
                line-height: 28px;
            }
        }
        img {
            width: 28px;
            height: 28px;
        }
        p {
            display: none;
        }
    }
}
</style>
